<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-btn color="primary" fab small dark @click="onAddNewClicked">
              <v-icon>add</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex sm6></v-flex>
              <v-flex sm6>
                <v-text-field
                  v-model="searchTable"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="desserts"
            :pagination.sync="pagination"
            :total-items="totalDesserts"
            :loading="loading"
            class="elevation-1"
            :rows-per-page-items="$CONFIG.tablePG"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.invoice_number }}</td>
                <td>{{ props.item.invoice_date }}</td>
                <td>{{ props.item.coordinators___name }}</td>
                <td>{{ props.item.companies___name }}</td>
                <td>{{ props.item.clients___name }}</td>
                <td>{{ props.item.amount }}</td>
                <td>
                  <v-menu offset-y transition="scale-transition">
                    <template v-slot:activator="{ on }">
                      <v-btn flat icon small color="primary" v-on="on">
                        <v-icon dark>more_vert</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in rowActionItems"
                        :key="index"
                        @click="onRowActionItemClicked(item.value, props.item)"
                      >
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <v-btn fab bottom right color="pink" dark fixed @click.stop="productsAddModal=true;">
      <v-icon>add</v-icon>
    </v-btn>-->

    <v-dialog v-model="isAddFormModal" scrollable persistent max-width="600px">
      <AddForm
        :clientTV="clientTV"
        :companyTV="companyTV"
        :coordinatorTV="coordinatorTV"
        :coordinators="coordinators"
        @cancelled="isAddFormModal = false"
        @added="getDataFromApi"
      />
    </v-dialog>
    <v-dialog v-model="isEditFormModal" scrollable persistent max-width="600px">
      <EditForm
        :clientTV="clientTV"
        :companyTV="companyTV"
        :coordinatorTV="coordinatorTV"
        :coordinators="coordinators"
        @cancelled="isEditFormModal = false"
        :edit-item="editItemNew"
      />
    </v-dialog>
    <v-dialog v-model="isDetailsModal" scrollable persistent max-width="800px">
      <DetailsView
        @cancelled="isDetailsModal = false"
        :item="editItemNew"
        :details="invoiceDetais"
        @paymentAdded="onPaymentAdded"
        @reload="loadInvoiceDetails"
      />
    </v-dialog>
  </div>
</template>

<script>
import Nl2br from "vue-nl2br";
import AddForm from "./InvoiceAdd.vue";
import EditForm from "./InvoiceEdit.vue";
import DetailsView from "./InvoiceDetails.vue";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

export default {
  components: {
    Nl2br,
    AddForm,
    EditForm,
    DetailsView,
  },
  data: () => ({
    actionButtonClicked: false,

    headers: [
      { text: "Invoice No.", value: "invoice_number" },
      { text: "Date", value: "invoice_date" },
      { text: "Coordinator", value: "coordinators___name" },
      { text: "Company", value: "companies___name" },
      { text: "Client", value: "clients___name" },
      { text: "Amount", value: "amount" },
      { text: "Actions", value: "name", sortable: false },
    ],

    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {
      sortBy: 'invoice_number',
      descending: true
    },
    getApiaParams: {
      // fields: "id,payment_date,method,amount,check_date,check_bank_name,check_bank_branch,check_number,account_head_id,notes",
      search_fields:
        "invoice_date,amount,companies___name,clients___name,coordinators___name",
    },
    searchTable: "",

    rowActionItems: [
      { title: "View Details", value: "details" },
      { title: "Edit", value: "edit" },
      { title: "Delete", value: "delete" },
    ],

    isAddFormModal: false,
    isEditFormModal: false,
    isDetailsModal: false,
    editItem: {},

    clients: [],
    companies: [],
    coordinators: [],

    invoiceDetais: {},
  }),

  computed: {
    clientTV() {
      return getTV(this.clients, { textField: "name", valueField: "id" });
    },
    companyTV() {
      return getTV(this.companies, { textField: "name", valueField: "id" });
    },
    coordinatorTV() {
      return getTV(this.coordinators, { textField: "name", valueField: "id" });
    },
    editItemNew() {
      return this.editItem && this.editItem.vat ? { ...this.editItem, vat_parcent: this.editItem.vat.slice(0, -1) } : {};
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    searchTable: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {},

  methods: {
    getDataFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      if (sortBy == null) {
        delete this.getApiaParams.sort;
      } else {
        this.getApiaParams.sort = descending ? "-" + sortBy : "+" + sortBy;
      }
      this.getApiaParams.limit = rowsPerPage;
      this.getApiaParams.offset = (page - 1) * rowsPerPage;
      this.getApiaParams.search = this.searchTable;

      this.get("/invoices", this.getApiaParams).then((response) => {
        this.desserts = response.data.data.items;
        this.totalDesserts = response.data.data.total_items;
        this.loading = false;
      });
    },
    loadClients() {
      this.get("/clients").then((response) => {
        this.clients = response.data.data;
      });
    },
    loadCompanies() {
      this.get("/companies").then((response) => {
        this.companies = response.data.data;
      });
    },
    loadCoordinators() {
      this.get("/coordinators").then((response) => {
        this.coordinators = response.data.data;
      });
    },
    onAddNewClicked() {
      this.isAddFormModal = true;
      this.loadClients();
      this.loadCompanies();
      this.loadCoordinators();
    },
    onEditClicked(item) {
      this.editItem = item;
      this.isEditFormModal = true;
      this.loadClients();
      this.loadCompanies();
      this.loadCoordinators();
    },
    onDetailsClicked(item) {
      this.editItem = item;
      this.isDetailsModal = true;
      this.loadInvoiceDetails();
    },
    async loadInvoiceDetails() {
      const { id } = this.selectedItem;
      const projectRes = await this.get(`/invoice_details/${id}`);
      this.invoiceDetais = projectRes.data;
    },
    onPaymentAdded(addedData){
      // console.log('addedData:', addedData);
      this.loadInvoiceDetails();
    },
    onRowActionItemClicked(action, item) {
      this.selectedItem = item;
      switch (action) {
        case "details":
          this.onDetailsClicked(item);
          break;
        case "edit":
          this.onEditClicked(item);
          break;
        case "delete":
          this.$confirm("Do you really want to DELETE invoice ?").then((isConfirmed) => {
            if (isConfirmed) {
              this.$http.delete("/invoice/" + item.id).then((res) => {
                if (res.data.success) {
                  this.desserts = this.desserts.filter((row) => row.id != item.id);
                }
                this.snackbarShow(res.data);
              });
            }
          });
          break;
      }
    },
  },

  beforeDestroy() {},
};
</script>
